import { FieldValidator } from './field-validator'

export class AlphaNumericFieldValidator implements FieldValidator<string> {
    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            if (!(text === undefined || text === '' || text === null) && !this.isAlphaNumeric(text)) {
                reject(`${fieldName}:Input cannot contain special characters`)
            } else {
                resolve('')
            }
        })
    }

    private isAlphaNumeric(text: string): boolean {
        return /^[a-z - 0-9]+$/i.test(text)
    }
}

export class AlphaNumericIncludesSpaceCheckFieldValidator implements FieldValidator<string> {
    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            if (!(text === undefined || text === '' || text === null) && !this.isAlphaNumeric(text)) {
                    reject(`${fieldName}: Input cannot contain special characters and spaces`)
            } else {
                resolve('')
            }
        })
    }

    private isAlphaNumeric(text: string): boolean {
        return /^[a-z0-9]+$/i.test(text);
    }
    
}
export class LettersonlyAllowedFieldValidator implements FieldValidator<string> {
    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            let regexVal = new RegExp("^[a-zA-Z.' ]*$");
            let isZLettersonlyValid = regexVal.test(text);
            if (!(text === undefined || text === '' || text === null) &&(!isZLettersonlyValid) ) {
                    reject(`${fieldName} :Input must be only letters allowed`)
            } else {
                resolve('')
            }
        })
    }

}
export class lettersCommaAndSpaceOnlyAllowedFieldValidator implements FieldValidator<string> {
    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            let regexVal = new RegExp('^[A-Za-z0-9\s.,-]+$' );
            let isZLettersonlyValid = regexVal.test(text);
            if (!(text === undefined || text === '' || text === null) &&(!isZLettersonlyValid) ) {
                    reject(`${fieldName} : Input must be only Letters, numbers, spaces and commas allowed`)
            } else {
                resolve('')
            }
        })
    }

}


export class emailValidFieldValidator implements FieldValidator<string> {
    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            let regexVal = new RegExp('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$' );
            let isZLettersonlyValid = regexVal.test(text);
            if (!(text === undefined || text === '' || text === null) &&(!isZLettersonlyValid) ) {
                    reject(`${fieldName} : Input must be only in email format`)
            } else {
                resolve('')
            }
        })
    }

}
export class phoneValidFieldValidator implements FieldValidator<string> {
    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            let regexVal = new RegExp('/^\d{10}$/' );
            let checkOrgPhone = text.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    reject(`${fieldName} :Input cannot contain letters or special characters.`)
                } else if( !(text!= undefined || text!= '' || text!=null)) {
                    reject(`${fieldName} :Input must be exactly 10 numbers.`)
                   
                }
        
            }
        })
    }
    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }
}


export class specialChracterNotAllowedFieldValidator implements FieldValidator<string> {
    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            let regexVal = new RegExp('^[^@,#,$,!,%,&,*]');
            let isZLettersonlyValid = regexVal.test(text);
            if (!(text === undefined || text === '' || text === null) &&(!isZLettersonlyValid) ) {
                    reject(`${fieldName} :Special character is not allowed`)
            } else {
                resolve('')
            }
        })
    }

}
export class accountNumberInvalidValidator implements FieldValidator<string> {
    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            let regexVal = RegExp('[0-9]{6}')
            let isZLettersonlyValid = regexVal.test(text);
            if (!(text === undefined || text === '' || text === null) &&(!isZLettersonlyValid) ) {
                    reject(`${fieldName} :Input six digit number is only allowed`)
            } else {
                resolve('')
            }
        })
    }

}
export class accountNameInvalidValidator implements FieldValidator<string> {
    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            let regexVal= new RegExp("^[a-zA-Z0-9 -. ']*$")
            let isZLettersonlyValid = regexVal.test(text);
            if (!(text === undefined || text === '' || text === null) &&(!isZLettersonlyValid) ) {
                    reject(`${fieldName} :Input must contain only letters, numbers, spaces, hyphens, periods, and apostrophes`)
            } else {
                resolve('')
            }
        })
    }

}


export class lettersSpaceshyphensAndApostrophesValidator implements FieldValidator<string> {
    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            let regexVal= new RegExp("^[a-zA-Z0-9 -. ']*$")
            let isZLettersonlyValid = regexVal.test(text);
            if (!(text === undefined || text === '' || text === null) &&(!isZLettersonlyValid) ) {
                    reject(`${fieldName} :Input must contain only letters, spaces, hyphens, and apostrophes.`)
            } else {
                resolve('')
            }
        })
    }

}


export class  lettersNumbersAndspacesValidator implements FieldValidator<string> {
    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            let regexVal= new RegExp("^[a-zA-Z0-9 ]*$")
            let isZLettersonlyValid = regexVal.test(text);
            if (!(text === undefined || text === '' || text === null) &&(!isZLettersonlyValid) ) {
                    reject(`${fieldName} :Input must contain only letters, numbers, and spaces..`)
            } else {
                resolve('')
            }
        })
    }

}
export class  lettersPeriodsApostrophesAndSpacesValidator implements FieldValidator<string> {
    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            let regexVal= new RegExp("^[a-zA-Z.' ]*$")
            let isZLettersonlyValid = regexVal.test(text);
            if (!(text === undefined || text === '' || text === null) &&(!isZLettersonlyValid) ) {
                    reject(`${fieldName} :Input must contain only letters, periods, apostrophes, and spaces`)
            } else {
                resolve('')
            }
        })
    }

}
export class  onlyDigitsValidator implements FieldValidator<string> {
    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            let regexVal= new RegExp("^[0-9]*$")
            let isZLettersonlyValid = regexVal.test(text);
            if (!(text === undefined || text === '' || text === null) &&(!isZLettersonlyValid) ) {
                    reject(`${fieldName} :Input must contain only digits`)
            } else {
                resolve('')
            }
        })
    }

}
export class  lettersPeriodsApostrophesSpacesAndHyphensValidator implements FieldValidator<string> {
    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            let regexVal= new RegExp("^[a-zA-Z.' -]*$")
            let isZLettersonlyValid = regexVal.test(text);
            if (!(text === undefined || text === '' || text === null) &&(!isZLettersonlyValid) ) {
                    reject(`${fieldName} :Input may only contain letters, periods, apostrophes, spaces, and hyphens`)
            } else {
                resolve('')
            }
        })
    }

}